import React, { useState, useEffect } from "react";
import { Form, Descriptions, Checkbox, Switch, Button } from "antd";
import { connect } from "react-redux";
import { Settings } from "../../models";
import { updateCurrentUserAction } from "../../redux/actions";
import { handleApiExceptions, alertify } from '../../app_methods';
import { Text2 } from "../../styles";

let TaxPayments = (props) => {
    const { form } = props;
    const { getFieldDecorator } = form;
    const [isSaving, setIsSaving] = useState(false);
    const [approvalFlow, setapprovalFlow] = useState(false);

    const SaveTaxConfig = async (payload) => {
        setIsSaving(true);
        const response = await Settings.update({ ...payload })
        if (!response.success) {
            handleApiExceptions(response);
            return;
        }
        setIsSaving(false);
    }

    const fetchTaxSettings = async () => {
        const response = await Settings.list()
        if (!response.success) {
            handleApiExceptions(response);
            return;
        }
        setapprovalFlow(response.data.tax_payments_settings.enable_tax_approver_flow);
    }

    const switchUpdate = (checked) => {
        SaveTaxConfig({ enable_tax_approver_flow: checked })
        setapprovalFlow(checked)
    }

    useEffect(() => {
        fetchTaxSettings()
    }, [])

    return (
        <Switch onChange={switchUpdate} disabled={isSaving} checked={approvalFlow}/>
    );
};


TaxPayments = Form.create()(TaxPayments);

const mapStateToProps = (state) => ({
    current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
    updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxPayments);